import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { CookieService } from "../_services/cookie.service";

declare const grecaptcha: any;

@Injectable({
    providedIn: 'root',
})
export class RecaptchaService {
    private siteKey: string = environment.recaptchaSiteKey;
    private apiURL = environment.apiURL;
    private isLoaded = false;

    public constructor(private http: HttpClient, private cookieService: CookieService) {
    }

    loadRecaptcha(): Promise<void> {

        return new Promise((resolve, reject) => {

            // Disattivata gestione cookie come da richiesta Doctorium dopo parere avvocato:
            // per loro sono cookie tecnici
            //const consent = localStorage.getItem('cookie-consent');
            const consent = 'true';

            if (consent !== 'true') {
                if (!environment.production) {
                    console.warn('[reCAPTCHA] Consenso cookie non presente. Script bloccato.');
                }
                reject('cookie-consent-denied');
                return;
            }

            if (this.isLoaded) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${environment.recaptchaSiteKey}`;
            script.async = true;
            script.defer = true;

            script.onload = () => {
                this.isLoaded = true;
                resolve();
            };

            script.onerror = (error) => {
                reject(`Failed to load reCAPTCHA script: ${error}`);
            };

            document.head.appendChild(script);
        });
    }

    execute(action: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (typeof grecaptcha === 'undefined') {
                return reject('reCAPTCHA script is not loaded');
            }
            grecaptcha.ready(() => {
                grecaptcha.execute(this.siteKey, { action }).then(
                    (token: string) => resolve(token),
                    (error: any) => reject(error)
                );
            });
        });
    }

    verifyToken(token: string) {
        const headers = new HttpHeaders({
            'X-XSRF-TOKEN': this.cookieService.getCookie('XSRF-TOKEN')
        })
        return this.http.post<any>(`${this.apiURL}/user/recaptcha`, {token: token}, {
            headers,
            withCredentials: true,
            observe: 'response'
        });
    }

    removeRecaptchaArtifacts(): void {
        // Rimuove il badge visibile
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) {
            badge.remove();
            if (!environment.production) {
                console.log('[reCAPTCHA] Badge rimosso');
            }
        }

        // Rimuove iframe e script reCAPTCHA (facoltativo)
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
            if (iframe.src && iframe.src.includes('google.com/recaptcha')) {
                iframe.remove();
            }
        });

        const script = document.getElementById('recaptcha-script');
        if (script) {
            script.remove();
        }

        // Disattiva flag locale
        this.isLoaded = false;
    }

}
